import Highway from '@dogstudio/highway/src/highway'
import MotionTime from './modules/MotionTime'
import lottie from 'lottie-web'
import gsap from 'gsap'
import hbwLogo from '../anims/HBWlogo.json'

import '../scss/_Home.scss'

export default class Home extends Highway.Renderer {
    onEnter() {
        this.prepareAnimations()

        const headerLogo = document.querySelector('.header__logo')

        gsap.to(headerLogo, {
            duration: 0.4,
            ease: 'expo.easeOut',
            opacity: 0,
        })

        // Unlocking the very first achievement
        const motionTime = new MotionTime()
        setTimeout(() => {
            motionTime.unlockItem(6)
        }, 2000)
    }

    onEnterCompleted() {
        lottie.loadAnimation({
            path: hbwLogo,
            loop: true,
            autoplay: true,
            container: document.querySelector('.logo__animation'),
        })

        this.introductionTl.play()
    }

    prepareAnimations() {
        this.introductionTl = new gsap.timeline({
            paused: true,
        })

        const linkAbout = document.querySelector('.link--about')
        const linkWorks = document.querySelector('.link--works')
        const logoAnimation = document.querySelector('.logo__animation')
        const electricDesign = document.querySelector('.electric__design')

        this.introductionTl.add(
            gsap.from(logoAnimation, {
                duration: 0.4,
                opacity: 0,
                scale: 1.4,
                ease: 'expo.easeOut',
            })
        )

        this.introductionTl.add(
            gsap.from(linkAbout, {
                duration: 0.4,
                x: 400,
                scale: 0,
                opacity: 0,
                ease: 'expo.easeOut',
            })
        )

        this.introductionTl.add(
            gsap.from(linkWorks, {
                duration: 0.4,
                x: -400,
                scale: 0,
                opacity: 0,
                ease: 'expo.easeOut',
            })
        )

        this.introductionTl.add(
            gsap.from(electricDesign, {
                duration: 0.2,
                scale: 1.4,
                opacity: 0,
                ease: 'expo.easeOut',
            })
        )
    }

    onLeave() {
        const linkAbout = document.querySelector('.link--about')
        const linkWorks = document.querySelector('.link--works')
        const logoAnimation = document.querySelector('.logo__animation')
        const electricDesign = document.querySelector('.electric__design')

        gsap.to([linkAbout, linkWorks, logoAnimation, electricDesign], {
            duration: 0.2,
            scale: 1.4,
            opacity: 0,
            stagger: 0.1,
            ease: 'expo.easeOut',
        })
    }

    onLeaveCompleted() {}
}
